import classnames from 'classnames'
import { FC, Children, useState, useCallback, useEffect } from 'react'

import { TabProperties, TabsProperties } from './types'

import styles from './Tabs.module.scss'

const Tabs: FC<TabsProperties> = ({ defaultActiveKey, children, activeKey, onChange }) => {
  const [selected, setSelected] = useState(defaultActiveKey)

  const onClick = useCallback(
    (key: string) => {
      setSelected(key)
      onChange?.(key)
    },
    [onChange]
  )

  useEffect(() => {
    if (activeKey) setSelected(activeKey)
  }, [activeKey])

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.tabs}>
          {Children.map(
            children,
            // eslint-disable-next-line
            (child: any) =>
              child ? (
                <button
                  type="button"
                  className={classnames(styles.button, {
                    [styles['button-active']]: selected === child.key,
                  })}
                  onClick={() => onClick(child.key)}
                >
                  {child.props.name}
                </button>
              ) : null
          )}
        </div>
      </div>
      <div className={styles.body}>
        {Children.map(
          children,
          // eslint-disable-next-line
          (child: any) => (child ? child.key === selected && child : null)
        )}
      </div>
    </div>
  )
}

const Tab: FC<TabProperties> = ({ children }) => <div className={styles.tab}>{children}</div>

export default { Tab, Tabs }
